import ReInvoice from '@/screens/finances/ReInvoice'

import auth from './middleware/auth'

const routes = [
  {
    path: '/reinvoice',
    name: 'ReInvoice',
    component: ReInvoice,
    meta: {
      requireAuth: true,
      permissions: ['provider'],
      middleware: { auth }
    }
  }
]

export default routes
